import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useUIStore } from '@/stores/uiStore';

export function DeleteConfirmModal() {
  const { modals, deleteConfirmData, closeDeleteConfirm } = useUIStore();

  const handleConfirm = () => {
    if (deleteConfirmData?.onConfirm) {
      deleteConfirmData.onConfirm();
    }
    closeDeleteConfirm();
  };

  return (
    <AlertDialog open={modals.deleteConfirm} onOpenChange={closeDeleteConfirm}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {deleteConfirmData?.title || '정말 삭제하시겠습니까?'}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {deleteConfirmData?.message ||
              '이 작업은 되돌릴 수 없습니다. 항목이 영구적으로 삭제됩니다.'}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>취소</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            삭제
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
